/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FunctionComponent, useCallback } from 'react';
import { TbLayoutSidebarLeftCollapse } from 'react-icons/tb';
import moment from 'moment';
import { openDialog } from '../../../../../app/dialog/dialog.actions';
import { useDispatch } from 'react-redux';
import Loader from 'react-loader-spinner';
import { INavigationBarProps } from './types';
import { Settings } from './Settings';
import { Notifications } from './Notifications';
import { Support } from './Support';
import { NextMeeting } from './NextMeeting';
import { authSelectors } from '../../../../../app/auth/auth.selectors';
import { useSelect, useSelectWithParams } from '../../../../../utils/selector.utils';
import { userSelectors } from '../../../../../app/resource/user/user.selectors';
import { convertDateToUserTimeZone } from '../../../../../utils/date.utils';
import { CircularAvatar } from '../../CustomAvatar';
import { useTenantBranding } from '../../../../../utils/custom-hooks/useTenantBranding.utils';

const NavigationBar: FunctionComponent<INavigationBarProps> = ({ showLoader, toggleSideBar, leftArrow, showHide }) => {
  const userId = useSelect(authSelectors.selectLoggedUser);
  const user = useSelectWithParams(userSelectors.selectResourceById, userId ? userId : '');
  const { iconLogo, tenantName } = useTenantBranding();

  const dispatch = useDispatch();
  const openWidgetsDialogDialog = useCallback(() => {
    dispatch(openDialog('widgetsDialog'));
  }, [dispatch]);

  let currentTime = moment().format('dddd, MM/DD, h:mma');
  if (user) {
    currentTime = convertDateToUserTimeZone(moment.utc().format(), user?.timezone).format('dddd, MM/DD, h:mma');
  }

  return (
    <div className="row mb-2">
      <div className="col-12">
        <div className="panel single-line">
          <a className="panel-button shrink-menu" style={{ cursor: 'pointer' }} onClick={toggleSideBar}>
            {showLoader ? (
              <Loader type="TailSpin" color="var(--theme-primary-color)" height={40} width={40} />
            ) : (
              <TbLayoutSidebarLeftCollapse
                className={` icon-left-arrow transition2 ${leftArrow ? 'icon-rotated' : ''}`}
                size={18}
              />
            )}
          </a>
          <div className="panel-text ml-2">
            <span className="darkGray">
              <i className="icon-clock mr-05"></i>
              {currentTime}
            </span>
          </div>
          {!showLoader && <NextMeeting />}
          <ul className="right-menu">
            <li className="panel-text ml-2">
              <CircularAvatar src={iconLogo} title={tenantName} size="30" />
            </li>
            <li className="panel-text ml-2 pr-2">{tenantName}</li>
            {showHide && (
              <li>
                <a
                  className="panel-button popup_button"
                  data-popup="sort_widgets_popup"
                  onClick={openWidgetsDialogDialog}
                >
                  <i className="icon-dots"></i>
                </a>
              </li>
            )}

            <Support />
            <Notifications />
            <Settings />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NavigationBar;
